import React, { FC, useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

import Button from 'b2b-ui-components-lib/lib/components/button';

import { ClickEventType } from 'home/view/check-feasibility/comp-generator/common-interface';

import './index.scss';

interface Props {
  percent: number;
  onCancelConfirmClick: (e: ClickEventType) => void;
}

export const ProgressBar: FC<Props> = ({ percent, onCancelConfirmClick }) => {
  const progressEleRef = useRef<HTMLDivElement | null>(null);

  const [showCancelModal, setShowCancelModal] = useState<boolean>(false);

  useEffect(() => {
    if (progressEleRef.current) {
      progressEleRef.current.style.width = `${percent}%`;
    }
  }, [percent, progressEleRef.current]);

  const progressLineClass = classNames({
    'progress-line': true,
    hide: percent === 0 || percent === 100
  });

  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  if (showCancelModal) {
    return (
      <div className="modal-custom open">
        <div className="modal_dialog contract_modal">
          <div className="modal_content">
            <div className="modal_header">
              <h5>Cancel File Upload</h5>
            </div>
            <div className="modal_body">
              <div className="plan_condition custom-modal-dec">Are you sure you want to cancel the file upload?</div>
              <div className="next_step">
                <Button variant="outlinebtn" onClick={() => setShowCancelModal(false)}>
                  Cancel
                </Button>
                <Button variant="activebtn" onClick={onCancelConfirmClick}>
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="progress-wrapper">
      <div className={progressLineClass}>
        <div className="progress-show" data-testid="progress-style" ref={progressEleRef}></div>
      </div>
      <div className="progress-status">
        Processing file... ({percent.toFixed(2)}%){' '}
        <span role="button" onClick={handleCancelClick}>
          Cancel
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
